import { geocodeByPlaceId } from 'react-google-places-autocomplete';
import { replaceDoubleSpaceToSingle } from 'utils';
import { fillInAddress, maskPhoneNum, maskDigits, maskLetters } from './../../../../utils';
import { US_STATES } from "utils/statesCodeOptions";

const updateState = (employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet) => {
    internalStateSetter({ employmentInformation: updatedEmploymentInformation })

    const updatedemploymentInformations = employmentInformations.map((item) => {
        if (((!!item.occupant_index && item.occupant_index === updatedEmploymentInformation.occupant_index) || (!!item.person_id && item.person_id === updatedEmploymentInformation.person_id))) {
            return updatedEmploymentInformation;
        }
        return item
    })

    outlet({ employmentInformations: updatedemploymentInformations })
}

export default {
    'EmploymentInfo.Wrapper.Location': ({ value, employmentInformations, resourceObj:employmentInformation }, outlet, internalStateSetter) => {
        const { place_id } = value
        geocodeByPlaceId(place_id)
        .then(r => {
            const address = fillInAddress(r[0].address_components);
            const selectedUSState = US_STATES.find(s => s.id === address?.state)
            if(!selectedUSState) {
                address["state"] = ""
            }
            
            const updatedEmploymentInformation = { ...employmentInformation, address, hasError: false, addressError: { addressError: '', cityError: '', stateError: '', zipError: ''} }
            updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
        })
        .catch(e => {})
    },
    'EmploymentInfo.Wrapper.AddressDetails.City': ({ employmentInformations, employmentInformation, value }, outlet, internalStateSetter) => {
        const maskedValue = maskLetters(value)
        const updatedEmploymentInformation = { ...employmentInformation, address: { ...employmentInformation.address, city: maskedValue, cityError: '' }, addressError: { ...employmentInformation.addressError, cityError: ''}, hasError: false }
        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.AddressDetails.State': ({ employmentInformations, employmentInformation, selectedOptionId }, outlet, internalStateSetter) => {
        const updatedEmploymentInformation = { ...employmentInformation, address: { ...employmentInformation.address, state: selectedOptionId, stateError: '' }, addressError: { ...employmentInformation.addressError, stateError: ''}, hasError: false }
        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.AddressDetails.Zip': ({ employmentInformations, employmentInformation, value }, outlet, internalStateSetter) => {
        
        const updatedEmploymentInformation = { ...employmentInformation, address: { ...employmentInformation.address, zip: value }, addressError: { ...employmentInformation.addressError, zipError: ''}, hasError: false }
        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.EmployerName': ({ employmentInformations, employmentInformation, value }, outlet, internalStateSetter) => {
        const updatedEmploymentInformation = { ...employmentInformation, employerName: replaceDoubleSpaceToSingle(value), employerNameError: '', hasError: false }
        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.Address': ({ employmentInformations, employmentInformation, value }, outlet, internalStateSetter) => {
        const updatedEmploymentInformation = { ...employmentInformation, address: value, addressError: '', hasError: false }
        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.PhoneNumber': ({ employmentInformations, employmentInformation, value }, outlet, internalStateSetter) => {

        const maskedNum = maskPhoneNum(value)
        const updatedEmploymentInformation = { ...employmentInformation, phoneNumber: maskedNum, phoneNumberError: '', hasError: false }
        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.Email': ({ employmentInformations, employmentInformation, value }, outlet, internalStateSetter) => {
        const updatedEmploymentInformation = { ...employmentInformation, email: value.trim(), emailError: '', hasError: false }
        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.SupervisorName': ({ employmentInformations, employmentInformation, value }, outlet, internalStateSetter) => {
        const updatedEmploymentInformation = { ...employmentInformation, supervisorName: replaceDoubleSpaceToSingle(value), supervisorNameError: '', hasError: false }
        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.DurationOfEmployment': ({ employmentInformations, employmentInformation, value }, outlet, internalStateSetter) => {
        const updatedEmploymentInformation = { ...employmentInformation, durationOfEmployment: value, durationOfEmploymentError: '', hasError: false }
        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.MonthlyIncome': ({ employmentInformations, employmentInformation, value }, outlet, internalStateSetter) => {
        const maskedNum = maskDigits(value)
        if(maskedNum.length > 5) return;

        const updatedEmploymentInformation = { ...employmentInformation, monthlyIncome: maskedNum, monthlyIncomeError: '', hasError: false }
        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.AddIncome': ({ employmentInformations, employmentInformation }, outlet, internalStateSetter) => {
        const updatedEmploymentInformation = { ...employmentInformation, hasExtraIncome: !employmentInformation.hasExtraIncome }
        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.OtherIncome.Header.Delete': ({ employmentInformations, employmentInformation }, internalStateSetter, outlet) => {
        const updatedEmploymentInformation = { ...employmentInformation, hasExtraIncome: false, otherIncome: { description: '', extraMonthlyIncome: '' } }
        updateState(employmentInformations, updatedEmploymentInformation, outlet, internalStateSetter)
    },
    'EmploymentInfo.Wrapper.OtherIncome.Description': ({ employmentInformations, employmentInformation, value }, outlet, internalStateSetter,) => {
        const updatedEmploymentInformation = {
            ...employmentInformation, hasError: false, 
            extra_income_description: value,
            extra_income_descriptionError: '', 
            extra_incomeError: ''
        }

        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
    'EmploymentInfo.Wrapper.OtherIncome.ExtraMonthlyIncome': ({ employmentInformations, employmentInformation, value }, outlet, internalStateSetter,) => {

        const maskedNum = maskDigits(value)
        if(maskedNum.length > 5) return;
        
        const updatedEmploymentInformation = {
            ...employmentInformation, hasError: false,
            extra_income: maskedNum,
            extra_income_descriptionError: '', 
            extra_incomeError: '',
        }

        updateState(employmentInformations, updatedEmploymentInformation, internalStateSetter, outlet)
    },
};
